var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('page-title', {
    attrs: {
      "title": "Import problemen",
      "icon": "pe-7s-cloud-upload"
    }
  }), _c('b-row', [_c('b-col', [_c('metabase', {
    attrs: {
      "identifier": "import_errors"
    }
  })], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }